<template>
  <v-row class="justify-space-between align-center mb-15">
    <v-col cols="12" sm="5" md="3">
      <CustomSelect
        v-if="selectedParam.type === 'select'"
        v-model.trim="selectedParam.value"
        append-icon="mdi-magnify"
        :items="mapSelectItems(selectedParam.name)"
        :placeholder="$t('label.' + selectedParam.placeholder)"
        hide-details
        :outlined="false"
        class="mr-3"
        @change="onAdd"
      />
      <CustomAutocomplete
        v-else-if="selectedParam.type === 'autocomplete'"
        v-model.trim="selectedParam.value"
        :items="mapSelectItems(selectedParam.name)"
        :placeholder="$t('label.' + selectedParam.placeholder)"
        hide-details
        :outlined="false"
        :clearable="false"
        :smallChips="false"
        class="mr-3"
        :return-object="selectedParam.isObjectValue"
        :item-value="selectedParam.itemValue"
        @change="onAdd"
      />
      <CustomInput
        v-else
        v-model.trim="selectedParam.value"
        append-icon="mdi-magnify"
        :placeholder="$t('label.' + selectedParam.placeholder)"
        hide-details
        :outlined="false"
        class="mr-5"
        @keydown.enter="onAdd"
        @click:append="onAdd"
      />
    </v-col>
    <v-col v-if="selectedFilters.length" cols="12" sm="7">
      <span v-for="param in selectedFilters" :key="param.name">
        <CustomChip v-if="param.value" class="mr-3" @click:close="$emit('delete', param)">
          {{ parseSelectValue(param) }}
        </CustomChip>
      </span>
    </v-col>
    <v-col cols="12" sm="5" md="2" class="d-md-flex justify-end">
      <ActionButton color="red" icon="mdi-delete" @click="$emit('clear')">
        {{ $t('button.clear') }}
      </ActionButton>
    </v-col>
  </v-row>
</template>
<script>
import substringLength from '@/helpers/substringLength'

export default {
  name: 'CustomTableFilter',
  props: {
    page: {
      type: String,
      default: '',
    },
    selectedParam: {
      type: Object,
      default: () => ({}),
    },
    selectedFilters: {
      type: Array,
      default: () => [],
    },
    statusItems: {
      type: Array,
      default: () => [],
    },
    statusBidderItems: {
      type: Array,
      default: () => [],
    },
    strategyItems: {
      type: Array,
      default: () => [],
    },
    campaignTypeItems: {
      type: Array,
      default: () => [],
    },
    ruleTypeItems: {
      type: Array,
      default: () => [],
    },
    ruleTypeRangeItems: {
      type: Array,
      default: () => [],
    },
    userNameItems: {
      type: Array,
      default: () => [],
    },
    categoryItems: {
      type: Array,
      default: () => [],
    },
    versionItems: {
      type: Array,
      default: () => [],
    },
    roleItems: {
      type: Array,
      default: () => [],
    },
    audienceTypeItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    itemsMap() {
      return {
        status: this.statusItems,
        bidderStatus: this.statusBidderItems,
        campaignType: this.campaignTypeItems,
        type: this.page === 'audience' ? this.audienceTypeItems : this.ruleTypeItems,
        timeRange: this.ruleTypeRangeItems,
        userId: this.userNameItems,
        login: this.userNameItems,
        category: this.categoryItems,
        rtbVersion: this.versionItems,
        roles: this.roleItems,
        strategy: this.strategyItems.map((item) => ({
          ...item,
          disabled: false,
        })),
      }
    },
  },
  methods: {
    substringLength,
    parseSelectValue(item) {
      const {value, isObjectValue} = item
      if (isObjectValue) {
        return substringLength(value.text)
      } else {
        return substringLength(value)
      }
    },
    mapSelectItems(name) {
      return this.itemsMap[name] || []
    },
    onAdd() {
      const value = this.selectedParam.value

      const isEmpty =
        value === null || value === undefined || (typeof value === 'string' && value.trim() === '')

      if (isEmpty) return

      this.$emit('add')
    },
  },
}
</script>
